import './utility/zod';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import '@fontsource/nunito-sans/400.css';
import '@fontsource/nunito-sans/500.css';
import '@fontsource/nunito-sans/600.css';
import '@fontsource/nunito-sans/700.css';
import './index.css';
import { themeConfig } from './styles/theme';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer, Zoom } from 'react-toastify';
import App from './App';
import { DeployWatcher } from './components/DeployWatcher';
import { theme } from './utility/theme';
import { AuthProvider } from './contexts/auth';
import 'react-toastify/dist/ReactToastify.css';
import 'semantic-ui-css/semantic.min.css';
import 'react-image-crop/dist/ReactCrop.css';
import 'react-datepicker/dist/react-datepicker.css';
// Design system last so its (prefixed) utilities win ties with the legacy stylesheets above.
import '@skupreme/shared/ui/styles.css';
import { IntegrationProvider } from './contexts/integrations';
import { GlobalProvider, SidebarMetadataProvider, SidebarProvider } from './contexts';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <ConfigProvider theme={themeConfig}>
      <QueryClientProvider client={queryClient}>
        <ToastContainer
          icon={false}
          enableMultiContainer
          transition={Zoom}
          theme="colored"
        />
        <Router>
          <DeployWatcher />
          <AuthProvider>
            <GlobalProvider>
              <SidebarMetadataProvider>
                <SidebarProvider>
                  <IntegrationProvider>
                    <App />
                  </IntegrationProvider>
                </SidebarProvider>
              </SidebarMetadataProvider>
            </GlobalProvider>
          </AuthProvider>
        </Router>
      </QueryClientProvider>
    </ConfigProvider>
  </ThemeProvider>,
);
